// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7g-0";
export var startPickingButton = "_7g-1";